import { render, staticRenderFns } from "./BaseFormSubtitle.vue?vue&type=template&id=e734ecb2&"
import script from "./BaseFormSubtitle.vue?vue&type=script&lang=ts&"
export * from "./BaseFormSubtitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports